import { localeLastWinsType } from '../en-US'

export const lastWins: localeLastWinsType = {
  casinoBets: 'Apuestas de Casino',
  game: 'Juego',
  provider: 'Proveedor',
  username: 'Nombre de usuario',
  player: 'Jugador',
  time: 'Hora / Tiempo',
  timeToWin: 'Es hora de ganar',
  multiplier: 'Multiplicador',
    betAmount: 'Monto de la apuesta',
  winAmount: 'Monto de la ganancia',
  privateOn: 'Modo privado activado',
  privateOff: 'Modo privado desactivado',
  stealth: 'Sigilo',
  privacyEnabledTooltip: 'Este usuario tiene la privacidad activada',

  tableTypes: {
    standard: 'Todas las apuestas',
    high_rollers: 'Grandes apostadores',
    lucky_bets: 'Apuestas afortunadas',
  },
}
